import React, { useContext } from "react";
import UserContext from "../context/UserContext";

import ecomr from "../assets/e.svg";

import "./home.css";
import { Button, Card } from "react-bootstrap";

import man from "../assets/man.jpg";
import women from "../assets/women.jpg";
import { Link } from "react-router-dom";

import esy from "../assets/icons/esy.png";
import pri from "../assets/icons/prium.png";
import unli from "../assets/icons/Unlimited.png";

function Home() {
  const { userData } = useContext(UserContext);

  return (
    <div className="Home">
      <>
        {userData.user ? (
          <>
            <div>
              <div className="Home_header">
                <div className="Home_header_text">
                  <p>e-temp</p>
                  <br />
                  <h2 style={{ fontWeight: "bold" }}>
                    Shine your life <br />
                    with e-temp product
                  </h2>
                  <br />
                  <Link to="/shop">
                    <Button
                      variant="dark"
                      style={{
                        borderRadius: "50px",
                        padding: "5px 25px 5px 25px ",
                      }}
                    >
                      Shop Now
                    </Button>
                  </Link>
                </div>
                <div className="Home_header_img">
                  <img src={ecomr} alt="" className="Home_header_img_main" />
                </div>
              </div>
              <div className="categoris">
                <div className="man">
                  <Link to="/man">
                    <Card className="bg-dark text-white">
                      <Card.Img src={man} alt="" className="man_img" />
                      <Card.ImgOverlay>
                        <Card.Text
                          style={{ marginTop: "450px" }}
                          className="text-center"
                        >
                          <b
                            style={{ fontSize: "50px", fontFamily: "cursive" }}
                          >
                            Man
                          </b>
                        </Card.Text>
                      </Card.ImgOverlay>
                    </Card>
                  </Link>
                </div>
                <div className="women">
                  <Link to="/woman">
                    <Card className="bg-dark text-white">
                      <Card.Img src={women} alt="" className="women_img" />
                      <Card.ImgOverlay>
                        <Card.Text
                          style={{ marginTop: "450px" }}
                          className="text-center"
                        >
                          <b
                            style={{ fontSize: "50px", fontFamily: "cursive" }}
                          >
                            Woman
                          </b>
                        </Card.Text>
                      </Card.ImgOverlay>
                    </Card>
                  </Link>
                </div>
              </div>
              <div className="motivation_1">
                <div className="esy">
                  <img src={unli} alt="" width="55px" height="55px" />
                  <div style={{ marginLeft: "15px" }}>
                    <h6>Unlimited Customization</h6>
                    <p>
                      Over 35 different dresses, <br /> available in 3 different
                      cuts.
                    </p>
                  </div>
                </div>
                <div className="esy">
                  <img src={pri} alt="" width="55px" height="55px" />
                  <div style={{ marginLeft: "15px" }}>
                    <h6>Premium Materials</h6>
                    <p>
                      Over 35 different dresses, <br /> available in 3 different
                      cuts.
                    </p>
                  </div>
                </div>
                <div className="esy">
                  <img src={esy} alt="" width="55px" height="55px" />
                  <div style={{ marginLeft: "15px" }}>
                    <h6>Easy to Apply</h6>
                    <p>
                      Over 35 different dresses, <br /> available in 3 different
                      cuts.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div>
              <div className="Home_header">
                <div className="Home_header_text">
                  <p>e-temp</p>
                  <br />
                  <h2 style={{ fontWeight: "bold" }}>
                    Shine your life <br />
                    with e-temp product
                  </h2>
                  <br />
                  <Link to="/shop">
                    <Button
                      variant="dark"
                      style={{
                        borderRadius: "50px",
                        padding: "5px 25px 5px 25px ",
                      }}
                    >
                      Shop Now
                    </Button>
                  </Link>
                </div>
                <div className="Home_header_img">
                  <img src={ecomr} alt="" className="Home_header_img_main" />
                </div>
              </div>
              <div className="categoris">
                <div className="man">
                  <Link to="/man">
                    <Card className="bg-dark text-white">
                      <Card.Img src={man} alt="" className="man_img" />
                      <Card.ImgOverlay>
                        <Card.Text
                          style={{ marginTop: "450px" }}
                          className="text-center"
                        >
                          <b
                            style={{ fontSize: "50px", fontFamily: "cursive" }}
                          >
                            Man
                          </b>
                        </Card.Text>
                      </Card.ImgOverlay>
                    </Card>
                  </Link>
                </div>
                <div className="women">
                  <Link to="/woman">
                    <Card className="bg-dark text-white">
                      <Card.Img src={women} alt="" className="women_img" />
                      <Card.ImgOverlay>
                        <Card.Text
                          style={{ marginTop: "450px" }}
                          className="text-center"
                        >
                          <b
                            style={{ fontSize: "50px", fontFamily: "cursive" }}
                          >
                            Woman
                          </b>
                        </Card.Text>
                      </Card.ImgOverlay>
                    </Card>
                  </Link>
                </div>
              </div>
              <div className="motivation_1">
                <div className="esy">
                  <img src={unli} alt="" width="55px" height="55px" />
                  <div style={{ marginLeft: "15px" }}>
                    <h6>Unlimited Customization</h6>
                    <p>
                      Over 35 different dresses, <br /> available in 3 different
                      cuts.
                    </p>
                  </div>
                </div>
                <div className="esy">
                  <img src={pri} alt="" width="55px" height="55px" />
                  <div style={{ marginLeft: "15px" }}>
                    <h6>Premium Materials</h6>
                    <p>
                      Over 35 different dresses, <br /> available in 3 different
                      cuts.
                    </p>
                  </div>
                </div>
                <div className="esy">
                  <img src={esy} alt="" width="55px" height="55px" />
                  <div style={{ marginLeft: "15px" }}>
                    <h6>Easy to Apply</h6>
                    <p>
                      Over 35 different dresses, <br /> available in 3 different
                      cuts.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    </div>
  );
}

export default Home;
